import {
  getNotificationLocation,
  parseNotificationNavSource,
} from "simplydo/core/notificationLocation";

const supportsPush = () => {
  if (!("Notification" in window)) {
    return false;
  }
  if (!("serviceWorker" in navigator)) {
    return false;
  }
  return true;
};

class ServiceWorkerBridge {
  _registration: ReturnType<typeof navigator.serviceWorker.register> | null =
    null;

  navigator: any;

  constructor() {
    if (supportsPush()) {
      this._registration = navigator.serviceWorker.register(
        import.meta.env.MODE !== "development" ?
          "/serviceWorker.js"
        : "/dev-sw.js?dev-sw",
        { type: import.meta.env.MODE !== "development" ? "classic" : "module" },
      );

      navigator.serviceWorker.addEventListener("message", (event) => {
        const { data } = event;
        if ("debug" in data) {
          console.info(data.debug);
        }
        if (data.ping) {
          // send message back
          navigator.serviceWorker.controller?.postMessage({ pong: true });
        }
        const navSource = parseNotificationNavSource(data);
        const path = navSource ? getNotificationLocation(navSource) : data.path;
        if (path && this.navigator) {
          this.navigator.push(path);
        }
      });
    }
  }

  getRegistration() {
    if (this._registration) {
      return this._registration;
    }
    return Promise.reject(new Error("Service worker not supported"));
  }
}

export const serviceWorkerBridge = new ServiceWorkerBridge();
